import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getDriverAnalyticsInfo } from '../../../redux/slices/hyperdrive/driverAnalytics';
import { useDispatch } from 'react-redux';
import { Box, Stack, Table, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MDButton from 'components/MDButton';
import Loader from 'common/Loader';
import { editTimeSimulation } from '../../../redux/slices/hyperdrive/setting';
import { openSnackbar } from '../../../redux/slices/common';
import NoDataFound from 'common/component/NoDataFound';

export default function TasktestingpanelDrawer({ closeModal }) {
    const { drawerData, drawer } = useSelector(state => state?.modal)
    const dispatch = useDispatch()
    const driverId = drawerData?._id
    const today = new Date();
    const next = new Date(today);
    next.setDate(today.getDate() + 1);
    const { driverDetails, loading: loading = false } = useSelector(state => state?.driverAnalyticsHyperDrive)
    const [rules, setRules] = useState([])

    // --- rewrite: use an array for editValues, so that each row has its own input ---
    const [editValues, setEditValues] = useState([])

    // Format date as YYYY-MM-DD
    const formatDate = date => date?.toISOString().slice(0, 10);
    const from = formatDate(today);
    const to = formatDate(next);

    useEffect(() => {
        const filters = {
            analyticType: "tasks",
            skip: 0,
            limit: 100,
            from,
            to,
        };
        dispatch(getDriverAnalyticsInfo({
            driverId,
            data: filters
        })).unwrap().then(res => {
        })
    }, [drawerData])

    // update editValues whenever tasks change
    useEffect(() => {
        if (driverDetails?.data?.tasks?.length) {
            setRules(driverDetails?.data?.tasks)
            setEditValues(driverDetails.data.tasks.map(t => t.time !== undefined ? String(t.time) : "")) // set initial values if available
        } else {
            setRules([])
            setEditValues([])
        }
    }, [driverDetails])

    // handle per-input change
    const handleInputChange = (value, idx) => {
        if (
            value === "" ||
            /^\d*\.?\d*$/.test(value)
        ) {
            setEditValues(prev => {
                const updated = [...prev]
                updated[idx] = value
                return updated
            })
        }
    }

    // if one input, then all fix this  
    // If user types in any input, update all inputs to that value
    const handleSingleInputChange = value => {
        if (
            value === "" ||
            /^\d*\.?\d*$/.test(value)
        ) {
            setEditValues(Array(rules.length).fill(value));
        }
    }

    // save handler
    const handleSave = (item, index) => {
        const value = editValues[index];
        if (!value) {
            dispatch(openSnackbar({ content: 'Time is required', color: 'error', icon: 'warning' }))
            return
        }
        const updated = [...rules]
        updated[index] = { ...item, time: Number(value) }
        setRules(updated)

        // prepare payload
        const payload = {
            taskId: item._id,
            time: Number(value)
        }
        dispatch(editTimeSimulation(payload)).then((res) => {
            showResponseMessage(res?.payload?.message, 'success');
        }).catch((err) => {
        })
    }

    const showResponseMessage = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }))
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }))
        }
    }

    return (
        <div className='hyperdrive-testing'>
            <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent='space-between' gap={2} px={3} py={2} style={{ borderBottom: "1px solid #F1F1F1" }}>
              {drawerData?.driverName &&  <Typography variant='h6' fontWeight="semibold" color="#656575">{drawerData?.driverName }</Typography>}
                <CloseIcon
                    fontSize="14px"
                    className='cur-pointer'
                    onClick={() => closeModal()}
                />
            </Stack>
            <Table className='on-duty-drivers'>
                <thead>
                    <tr>
                        <th>
                            <Typography className='text-12 text-left' style={{ color: "#2E2E3A", fontWeight: "600" }}>Task ID</Typography>
                        </th>
                        <th>
                            <Typography className='text-12 text-left' style={{ color: "#2E2E3A", fontWeight: "600" }}>Minute</Typography>
                        </th>
                        <th>
                            <Typography className='text-12 text-right' style={{ color: "#2E2E3A", fontWeight: "600" }}>Action</Typography>
                        </th>
                    </tr>
                </thead>
                {loading ? (
                    <tr>
                        <td colSpan='3'>
                            <Box className=''>
                                <Loader />
                            </Box>
                        </td>
                    </tr>
                ) : (
                    <tbody>
                        {rules?.length === 0 ? (
                            <tr>
                                <td colSpan={3}>
                                    <Box display="flex" alignItems="center" justifyContent="center" style={{ height: "400px" }} className="testing-drawer-no-data">
                                        <NoDataFound />
                                    </Box>
                                </td>
                            </tr>
                        ) : (
                            rules?.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <Typography className='text-14' style={{ color: "#2E2E3A" }}>{item.taskDisplayId}</Typography>
                                    </td>
                                    <td>
                                        <Box className="field-date">
                                            <TextField
                                                type="text"
                                                inputProps={{
                                                    inputMode: "decimal",
                                                    pattern: "[0-9.]*",
                                                    maxLength: 8,
                                                }}
                                                onWheel={(e) => e.target.blur()}
                                                fullWidth
                                                value={editValues[index] || ""}
                                                onChange={e => {
                                                    if (rules.length === 1) {
                                                        handleSingleInputChange(e.target.value);
                                                    } else {
                                                        handleInputChange(e.target.value, index);
                                                    }
                                                }}
                                            />
                                        </Box>
                                    </td>
                                    <td>
                                        <Box style={{ display: 'flex', gap: 8, justifyContent: "end" }}>
                                            <MDButton
                                                type='button'
                                                variant='outlined'
                                                color='dark'
                                                size="small"
                                                onClick={() => handleSave(item, index)}
                                                sx={{ borderRadius: 1.5 }}
                                            >
                                                Update
                                            </MDButton>
                                        </Box>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                )}
            </Table>
        </div>
    )
}
